module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Gantt"
    }
  }, [(_vm.tasks.length == 0) ? _c('p', [_vm._v("No tasks out there...")]) : _vm._e(), _vm._v(" "), (_vm.tasks.length > 0) ? _c('div', {
    attrs: {
      "id": "chart"
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37b65c12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gantt.vue
// module id = 162
// module chunks = 2